var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "page pageAsOverlay thePage" },
    [
      _c(
        "div",
        { staticClass: "prelative" },
        [
          _c("AppHead", { staticStyle: { "pointer-events": "none" } }),
          _c("div", {
            staticClass: "absCatcher",
            on: { click: _vm.closeDialog },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "spacer-25" }),
      _c(
        "v-container",
        { staticClass: "text-center", attrs: { "grid-list-lg": "" } },
        [
          !_vm.started
            ? _c(
                "div",
                [
                  _vm.detectedCode
                    ? _c("h3", [_vm._v("Erkannte Tischnummer")])
                    : _vm._e(),
                  _vm.detectedCode
                    ? _c("v-text-field", {
                        staticClass: "mt-10",
                        attrs: {
                          label: "Tischnummer",
                          placeholder: "",
                          illed: "",
                          required: "",
                        },
                        model: {
                          value: _vm.detectedCode,
                          callback: function ($$v) {
                            _vm.detectedCode = $$v
                          },
                          expression: "detectedCode",
                        },
                      })
                    : _vm._e(),
                  _c("div"),
                  _c(
                    "div",
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "btn-df mt-15",
                          on: { click: _vm.startScan },
                        },
                        [_vm._v("Tisch QR-Code einscannen")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "mt-10 btn-mini",
                          nativeOn: {
                            "&click": function ($event) {
                              return _vm.cancle.apply(null, arguments)
                            },
                          },
                        },
                        [_vm._v(" Abbrechen ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _vm._m(0),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.started,
              expression: "started",
            },
          ],
          staticClass: "pt-10 text-center",
        },
        [
          _c("div", { staticClass: "text-center pt-4 pb-4" }, [
            _c(
              "div",
              [
                _c(
                  "v-btn",
                  { staticClass: "btn-mini", on: { click: _vm.stopScan } },
                  [_vm._v("Abbrechen")]
                ),
              ],
              1
            ),
          ]),
          _vm.showHint
            ? _c("h3", { staticClass: "mt-6" }, [
                _vm._v(
                  "Bitte überprüfe die Kamera-Berechtigung in deinen Browser-Einstellungen, falls die Kamera jetzt nicht angezeigt wird."
                ),
              ])
            : _vm._e(),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "superCenter" }, [
      _c("video", { staticClass: "vVideo", attrs: { id: "tableQrVideoElem" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }